import { render, staticRenderFns } from "./ProductTransactionList.vue?vue&type=template&id=94f4e82a&scoped=true"
import script from "./ProductTransactionList.vue?vue&type=script&lang=js"
export * from "./ProductTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f4e82a",
  null
  
)

export default component.exports